module.exports = __webpack_public_path__ + "img/chest-bottom.5f02766e.svg";